import { Navigate } from "react-router-dom";

/**
 * RoleRedirect — ใช้แทน Home ที่ route "/"
 * ถ้า login แล้ว → redirect ตาม role
 * ถ้ายังไม่ login → แสดง Home ปกติ
 */
import Home from "../pages/Home";


function RoleRedirect() {
  const token = localStorage.getItem("token");
  const role  = localStorage.getItem("role");

  if (token && role === "admin") return <Navigate to="/admin"    replace />;
  if (token && role === "staff") return <Navigate to="/calendar" replace />;

  // user ทั่วไป หรือยังไม่ login → Home
  return <Home />;
}

export default RoleRedirect;